import React from 'react';
import { useStyletron } from 'baseui';
import { colorWithOpacity } from '../../../../../common/utils/color-with-opacity';
import { ANNOTATION_TINT_OPACITY } from '../../../constants/frame-timeline-v4';
import type { AnnotationRowDescriptorT, TimelineActionsT } from '../../../types/frame-timeline-v4';
import { isKeyframe } from '../../../utils/frame-span-utils';
import { getSpanAtFrame } from '../../../utils/frame-timeline-v4';
import { AnnotationSpanPopoverContent } from '../span-popover/annotation-span-popover-content';
import { SpanPopover } from '../span-popover/span-popover';
import { KeyframeDiamond } from './keyframe-diamond';
import { SpanPiece } from './span-piece';
import { SpanValueLabel } from './span-value-label';
type AnnotationCellPropsT = {
  row: AnnotationRowDescriptorT;
  frame: number;
  cellWidth: number;
  timelineActions?: TimelineActionsT;
  isSelected?: boolean;
};
export const AnnotationCell = React.memo(function AnnotationCell({
  row,
  frame,
  cellWidth,
  timelineActions,
  isSelected = false
}: AnnotationCellPropsT) {
  const [, theme] = useStyletron();
  const frameIndex = frame - 1;
  const result = getSpanAtFrame(row.spans, frameIndex);
  if (!result) {
    return null;
  }
  const {
    span,
    position
  } = result;
  const annotationColor = row.color ?? theme.colors.borderSelected;
  const showDiamond = isKeyframe(frameIndex, row.keyframes);
  return <SpanPopover content={({
    close
  }) => <AnnotationSpanPopoverContent annotationId={row.id} span={span} close={close} onDelete={timelineActions?.onDeleteAnnotationSpan} />}>
      <SpanPiece position={position} resizable clickable cellWidth={cellWidth} overrides={{
      fillColor: colorWithOpacity(annotationColor, ANNOTATION_TINT_OPACITY),
      borderColor: isSelected ? annotationColor : 'transparent',
      handleColor: annotationColor
    }}>
        {showDiamond ? <KeyframeDiamond color={annotationColor} /> : null}
        <SpanValueLabel value={span.value} framesIntoSpan={frameIndex - span.start} position={position} cellWidth={cellWidth} />
      </SpanPiece>
    </SpanPopover>;
});